import React from 'react';
import LimitSelector from './Contact/LimitSelector';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  currentLimit, 
  onLimitChange, 
  totalContacts 
}) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  
  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return pages;
    }
    
    if (currentPage <= 3) {
      return [...pages.slice(0, 5), '...', totalPages];
    } else if (currentPage >= totalPages - 2) {
      return [1, '...', ...pages.slice(totalPages - 5)];
    } else {
      return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
    }
  };

  return (
    <div className="flex justify-between items-center mt-4 px-4 py-2 bg-white border rounded-md">
      <div className="flex items-center justify-between w-[40%]">
        <div className="text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </div>
        <LimitSelector 
          currentLimit={currentLimit}
          onLimitChange={onLimitChange}
          totalContacts={totalContacts}
        />
      </div>
      
      <div className="flex space-x-1">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded-md ${
            currentPage === 1 
              ? 'text-gray-400 cursor-not-allowed' 
              : 'text-[#3985b6] hover:bg-gray-100'
          }`}
        >
          Previous
        </button>
        
        {getPageNumbers().map((page, index) => (
          <button
            key={index}
            onClick={() => typeof page === 'number' ? onPageChange(page) : null}
            className={`px-3 py-1 rounded-md ${
              page === currentPage
                ? 'bg-[#3985b6] text-white'
                : typeof page === 'number'
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-gray-500 cursor-default'
            }`}
          >
            {page}
          </button>
        ))}
        
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded-md ${
            currentPage === totalPages 
              ? 'text-gray-400 cursor-not-allowed' 
              : 'text-[#3985b6] hover:bg-gray-100'
          }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;